export enum BrandCampaignPromoAdsPage {
  Settings = "settings",
  MarketingChannels = "marketing-channels",
}
